import React from "react";

export const DarkModeContext = React.createContext();
